import Nullstack from 'nullstack';
export default function IconCurrencyForint({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-currency-forint",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M11 4h-4a3 3 0 0 0 -3 3v12"
  }), "   ", Nullstack.element("path", {
    d: "M10 11h-6"
  }), "   ", Nullstack.element("path", {
    d: "M16 4v13a2 2 0 0 0 2 2h2"
  }), "   ", Nullstack.element("path", {
    d: "M19 9h-5"
  }), " ");
}